module.exports = "<a href=\"https://www.grimstad.kommune.no/\">\n  <img src=\"assets/grimstad.png\" />\n</a>\n"